var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoomLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 3817.4399,
    height: 419.73334,
    viewBox: "1300 -100 1300 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 10840.9,0 v 360.77 h 256.6 v -24.731 h -229.8 V 194.281 h 206.6 v -24.73 h -206.6 V 24.7305 h 232.4 V 0 Z",
    id: "path58"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,10675.2,37.0302)",
    spreadMethod: "pad",
    id: "linearGradient72"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop62"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop64"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop66"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop68"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop70"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11671.9,0 -254.1,320.582 V 0 h -25.7 v 360.77 h 25.2 l 249,-313.8481 V 360.77 h 25.7 V 0 Z",
    id: "path80"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,10784.2,-187.51)",
    spreadMethod: "pad",
    id: "linearGradient94"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop84"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop86"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop88"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop90"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop92"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12131.9,336.039 V 0 h -26.8 v 336.039 h -125.8 v 24.731 h 278.3 v -24.731 z",
    id: "path102"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,10882.1,-389.27)",
    spreadMethod: "pad",
    id: "linearGradient116"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop106"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop108"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop110"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop112"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop114"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath126"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 12545,0 v 360.77 h 256.6 v -24.731 h -229.8 V 194.281 h 206.6 v -24.73 h -206.6 V 24.7305 h 232.4 V 0 Z",
    id: "path124"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11000.2,-632.45)",
    spreadMethod: "pad",
    id: "linearGradient138"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop128"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop130"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop132"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop134"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop136"
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13349.7,257.191 c 0,48.45 -38.1,78.848 -103.6,78.848 H 13123 v -162.34 h 121.6 c 60.3,0 105.1,30.41 105.1,82.442 z M 13355.9,0 13241,149.461 h -118 V 0 h -26.8 v 360.77 h 151.5 c 77.8,0 128.8,-42.29 128.8,-102.579 v -1 c 0,-60.332 -44.8,-94.851 -105.6,-103.101 L 13389.9,0 Z",
    id: "path146"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11108.6,-855.78)",
    spreadMethod: "pad",
    id: "linearGradient160"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop150"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop152"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop154"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop156"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop158"
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13796.3,336.039 V 0 h -26.8 v 336.039 h -125.8 v 24.731 h 278.3 v -24.731 z",
    id: "path168"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11199.6,-1043.17)",
    spreadMethod: "pad",
    id: "linearGradient182"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop172"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop174"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop176"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop178"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop180"
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14312.5,333.949 -95.4,-208.699 h 190.2 z M 14464.5,0 l -45.9,101.012 h -212.8 L 14159.9,0 h -27.8 l 168,363.352 h 25.8 L 14493.9,0 Z",
    id: "path190"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11328.2,-1308.09)",
    spreadMethod: "pad",
    id: "linearGradient204"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop194"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop196"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop198"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop200"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop202"
  })), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath214"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14779.7,0 v 360.77 h 26.8 V 0 Z",
    id: "path212"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11404.2,-1464.73)",
    spreadMethod: "pad",
    id: "linearGradient226"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop216"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop218"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop220"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop222"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop224"
  })), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath236"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15403.1,0 15149,320.582 V 0 h -25.8 v 360.77 h 25.3 L 15397.4,46.9219 V 360.77 h 25.8 V 0 Z",
    id: "path234"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11495.8,-1653.37)",
    spreadMethod: "pad",
    id: "linearGradient248"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop238"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop240"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop242"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop244"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop246"
  })), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 16049.6,0 v 313.328 l -142.8,-207.687 h -2.1 L 15762,313.328 V 0 h -25.8 v 360.77 h 25.3 l 144.8,-213.372 144.8,213.372 h 25.3 V 0 Z",
    id: "path256"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11616.6,-1902.1)",
    spreadMethod: "pad",
    id: "linearGradient270"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop260"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop262"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop264"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop266"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop268"
  })), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 16389.4,0 v 360.77 h 256.7 v -24.731 h -229.9 V 194.281 h 206.7 v -24.73 h -206.7 V 24.7305 h 232.5 V 0 Z",
    id: "path278"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11733.4,-2142.83)",
    spreadMethod: "pad",
    id: "linearGradient292"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop282"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop284"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop286"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop288"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop290"
  })), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath302"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 17220.5,0 -254.1,320.582 V 0 h -25.8 v 360.77 h 25.3 L 17214.8,46.9219 V 360.77 h 25.8 V 0 Z",
    id: "path300"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11842.4,-2367.37)",
    spreadMethod: "pad",
    id: "linearGradient314"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop304"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop306"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop308"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop310"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop312"
  })), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath324"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17680.4,336.039 V 0 h -26.8 v 336.039 h -125.7 v 24.731 h 278.3 v -24.731 z",
    id: "path322"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11940.4,-2569.13)",
    spreadMethod: "pad",
    id: "linearGradient336"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3880be"
    },
    offset: 0,
    id: "stop326"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#3c3e9e"
    },
    offset: 0.2513,
    id: "stop328"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#412464"
    },
    offset: 0.5005,
    id: "stop330"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4d174b"
    },
    offset: 0.7304,
    id: "stop332"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#91104b"
    },
    offset: 1,
    id: "stop334"
  })), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath346"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11792.8,628.391 h -660.6 c -160.9,0 -291.3,130.437 -291.3,291.339 v 660.6 608.37 660.6 c 0,160.91 130.4,291.35 291.3,291.35 h 660.6 c 242.9,0 464.5,-90.93 632.7,-240.65 -195.9,-174.36 -319.3,-428.43 -319.3,-711.3 v -608.37 c 0,-282.86 123.4,-536.94 319.3,-711.299 -168.2,-149.711 -389.8,-240.64 -632.7,-240.64 M 11476.4,2502.1 V 1266.94 h 316.4 c 173.1,0 313.4,140.31 313.4,313.39 v 608.38 c 0,173.08 -140.3,313.39 -313.4,313.39 h -316.4",
    id: "path344"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,10114.1,1192.94)",
    spreadMethod: "pad",
    id: "linearGradient358"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4494c5"
    },
    offset: 0,
    id: "stop348"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5651ac"
    },
    offset: 0.2513,
    id: "stop350"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#622688"
    },
    offset: 0.5005,
    id: "stop352"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#6b216b"
    },
    offset: 0.7304,
    id: "stop354"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#a11b67"
    },
    offset: 1,
    id: "stop356"
  })), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13058.2,628.391 c -242.9,0 -464.5,90.929 -632.7,240.64 195.9,174.359 319.3,428.439 319.3,711.299 v 608.37 c 0,282.87 -123.4,536.94 -319.3,711.3 168.2,149.72 389.8,240.65 632.7,240.65 242.9,0 464.5,-90.93 632.7,-240.65 -195.9,-174.36 -319.3,-428.43 -319.3,-711.3 v -608.37 c 0,-282.86 123.4,-536.94 319.3,-711.299 -168.2,-149.711 -389.8,-240.64 -632.7,-240.64 m 0,1873.709 c -173.1,0 -313.4,-140.31 -313.4,-313.4 v -608.37 c 0,-173.08 140.3,-313.39 313.4,-313.39 173.1,0 313.4,140.31 313.4,313.39 v 608.37 c 0,173.09 -140.3,313.4 -313.4,313.4",
    id: "path366"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,10403.9,595.97)",
    spreadMethod: "pad",
    id: "linearGradient380"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4494c5"
    },
    offset: 0,
    id: "stop370"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5651ac"
    },
    offset: 0.2513,
    id: "stop372"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#622688"
    },
    offset: 0.5005,
    id: "stop374"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#6b216b"
    },
    offset: 0.7304,
    id: "stop376"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#a11b67"
    },
    offset: 1,
    id: "stop378"
  })), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath390"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 12425.5,869.031 c -195.9,174.359 -319.3,428.439 -319.3,711.299 v 608.37 c 0,282.87 123.4,536.94 319.3,711.3 195.9,-174.36 319.3,-428.43 319.3,-711.3 v -608.37 c 0,-282.86 -123.4,-536.94 -319.3,-711.299",
    id: "path388"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath402"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14323.5,628.391 c -242.9,0 -464.5,90.929 -632.6,240.64 195.8,174.359 319.2,428.439 319.2,711.299 v 608.37 c 0,282.87 -123.4,536.94 -319.2,711.3 168.1,149.72 389.7,240.65 632.6,240.65 240.9,0 460.9,-89.46 628.6,-236.99 -193.5,-174.25 -315.2,-426.73 -315.2,-707.61 V 941.781 c 0,-84.5 37.8,-166.562 92.2,-222.929 -123,-58.02 -260.5,-90.461 -405.6,-90.461 m 0,1873.709 c -173.1,0 -313.4,-140.31 -313.4,-313.4 v -608.37 c 0,-173.08 140.3,-313.39 313.4,-313.39 173.1,0 313.4,140.31 313.4,313.39 v 608.37 c 0,173.09 -140.3,313.4 -313.4,313.4",
    id: "path400"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,10645.2,98.8499)",
    spreadMethod: "pad",
    id: "linearGradient414"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4494c5"
    },
    offset: 0,
    id: "stop404"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5651ac"
    },
    offset: 0.2513,
    id: "stop406"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#622688"
    },
    offset: 0.5005,
    id: "stop408"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#6b216b"
    },
    offset: 0.7304,
    id: "stop410"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#a11b67"
    },
    offset: 1,
    id: "stop412"
  })), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath424"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13690.9,869.031 c -195.9,174.359 -319.3,428.439 -319.3,711.299 v 608.37 c 0,282.87 123.4,536.94 319.3,711.3 195.8,-174.36 319.2,-428.43 319.2,-711.3 v -608.37 c 0,-282.86 -123.4,-536.94 -319.2,-711.299",
    id: "path422"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath436"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 15245.5,1342.33 c 0,0.06 0,0.12 0,0.19 0,-0.06 0,-0.13 0,-0.19 m 1.1,4.38 v 0 0 m 1.4,5.7 c 0,0.02 0,0.06 0,0.08 0,-0.03 0,-0.05 0,-0.08 m 1.1,4.28 c 0,0.04 0,0.06 0,0.1 0,-0.03 0,-0.07 0,-0.1 m 1,4.23 c 0,0.09 0,0.15 0,0.23 0,-0.06 0,-0.17 0,-0.23 m 0.9,4.19 c 0.1,0.15 0.1,0.25 0.1,0.41 0,-0.15 0,-0.26 -0.1,-0.41 m 1,4.32 c 0.1,0.11 0.1,0.24 0.1,0.35 0,-0.12 0,-0.23 -0.1,-0.35 m 0.4,1.6 c 0,0.11 0,0.18 0.1,0.29 -0.1,-0.09 -0.1,-0.2 -0.1,-0.29 m 0.6,2.84 c 0,0.04 0,0.12 0.1,0.17 0,-0.03 -0.1,-0.14 -0.1,-0.17 m 0.3,1.42 c 0.1,0.15 0.1,0.29 0.1,0.44 0,-0.15 0,-0.29 -0.1,-0.44 m 1,4.28 c 0,0.16 0,0.3 0.1,0.45 -0.1,-0.15 -0.1,-0.3 -0.1,-0.45 m 0.9,4.25 c 0,0.18 0,0.38 0.1,0.55 -0.1,-0.18 -0.1,-0.37 -0.1,-0.55 m 0.3,1.7 c 0.1,0.18 0.1,0.39 0.1,0.56 0,-0.21 0,-0.35 -0.1,-0.56 m 0.5,2.48 c 0.1,0.24 0.1,0.48 0.2,0.72 -0.1,-0.24 -0.1,-0.48 -0.2,-0.72 m 0.4,1.82 c 0,0.18 0.1,0.37 0.1,0.54 0,-0.18 -0.1,-0.36 -0.1,-0.54 m 0.5,2.61 c 0.1,0.18 0.1,0.36 0.1,0.54 0,-0.18 0,-0.36 -0.1,-0.54 m 0.4,1.64 c 0,0.24 0.1,0.48 0.1,0.72 0,-0.24 -0.1,-0.48 -0.1,-0.72 m 0.5,2.55 c 0,0.24 0,0.44 0.1,0.68 -0.1,-0.24 -0.1,-0.44 -0.1,-0.68 m 0.3,1.77 c 0.1,0.24 0.1,0.45 0.1,0.69 0,-0.21 -0.1,-0.48 -0.1,-0.69 m 0.3,1.73 c 0.1,0.51 0.2,0.97 0.3,1.47 -0.1,-0.48 -0.2,-0.98 -0.3,-1.47 m 0.5,2.57 c 0.1,0.22 0.1,0.45 0.2,0.67 -0.1,-0.21 -0.1,-0.46 -0.2,-0.67 m 0.4,1.81 c 0,0.04 0,0.12 0,0.16 0,-0.06 0,-0.1 0,-0.16 m 0.4,2.54 c 0.1,0.2 0.1,0.43 0.2,0.63 -0.1,-0.22 -0.1,-0.41 -0.2,-0.63 m 0.4,1.73 c 0,0.23 0,0.42 0.1,0.64 -0.1,-0.21 -0.1,-0.42 -0.1,-0.64 m 0.4,2.47 c 0.1,0.28 0.1,0.53 0.1,0.82 0,-0.28 -0.1,-0.55 -0.1,-0.82 m 0.3,1.83 c 0.1,0.24 0.1,0.51 0.2,0.75 -0.1,-0.25 -0.1,-0.51 -0.2,-0.75 m 0.5,2.45 c 0,0.29 0.1,0.56 0.1,0.85 0,-0.3 -0.1,-0.54 -0.1,-0.85 m 0.3,1.82 c 0,0.29 0.1,0.58 0.1,0.87 0,-0.31 -0.1,-0.57 -0.1,-0.87 m 0.4,2.28 c 0,0.35 0.1,0.73 0.1,1.09 0,-0.37 -0.1,-0.72 -0.1,-1.09 m 0.3,2.05 c 0.1,0.29 0.1,0.57 0.2,0.86 -0.1,-0.31 -0.1,-0.56 -0.2,-0.86 m 0.3,1.82 c 0.1,0.51 0.2,1.04 0.3,1.55 -0.1,-0.52 -0.2,-1.03 -0.3,-1.55 m 0.4,2.47 c 0.1,0.31 0.1,0.61 0.2,0.92 -0.1,-0.31 -0.1,-0.61 -0.2,-0.92 m 0.3,1.87 c 0.1,0.4 0.2,0.83 0.2,1.23 -0.1,-0.43 -0.1,-0.8 -0.2,-1.23 m 0.4,2.35 c 0.1,0.36 0.1,0.7 0.2,1.05 -0.1,-0.34 -0.2,-0.71 -0.2,-1.05 m 0.3,1.96 c 0.1,0.34 0.1,0.71 0.2,1.05 -0.1,-0.34 -0.1,-0.71 -0.2,-1.05 m 0.4,2.29 c 0,0.37 0.1,0.8 0.1,1.18 0,-0.4 -0.1,-0.78 -0.1,-1.18 m 0.3,2.04 c 0,0.35 0.1,0.67 0.1,1.02 0,-0.34 -0.1,-0.69 -0.1,-1.02 m 0.3,2.07 c 0,0.44 0.1,0.89 0.2,1.34 -0.1,-0.46 -0.1,-0.88 -0.2,-1.34 m 0.3,2.34 c 0.1,0.29 0.1,0.59 0.2,0.88 -0.1,-0.28 -0.1,-0.6 -0.2,-0.88 m 0.3,1.83 c 0.1,0.52 0.1,1.04 0.2,1.55 -0.1,-0.49 -0.1,-1.05 -0.2,-1.55 m 0.4,2.48 c 0,0.31 0,0.67 0.1,0.99 -0.1,-0.34 -0.1,-0.65 -0.1,-0.99 m 0.2,1.81 c 0.1,0.45 0.1,0.94 0.2,1.39 -0.1,-0.47 -0.1,-0.92 -0.2,-1.39 m 0.4,2.5 c 0,0.33 0,0.68 0.1,1.02 -0.1,-0.34 -0.1,-0.68 -0.1,-1.02 m 0.2,1.91 c 0.1,0.4 0.1,0.81 0.2,1.22 -0.1,-0.41 -0.1,-0.82 -0.2,-1.22 m 0.3,2.24 c 0.1,0.43 0.1,0.83 0.2,1.26 -0.1,-0.44 -0.1,-0.83 -0.2,-1.26 m 0.3,2.09 c 0,0.4 0.1,0.75 0.1,1.15 0,-0.37 -0.1,-0.78 -0.1,-1.15 m 0.2,1.98 c 0.1,0.54 0.2,1.07 0.3,1.61 -0.1,-0.56 -0.2,-1.05 -0.3,-1.61 m 0.3,2.32 c 0.1,0.43 0.1,0.83 0.2,1.26 -0.1,-0.43 -0.1,-0.82 -0.2,-1.26 m 0.3,1.92 c 0.1,0.58 0.1,1.16 0.2,1.74 -0.1,-0.56 -0.1,-1.18 -0.2,-1.74 m 0.3,2.43 c 0,0.41 0.1,0.82 0.1,1.22 0,-0.4 -0.1,-0.81 -0.1,-1.22 m 0.2,1.98 c 0.1,0.58 0.2,1.14 0.2,1.72 0,-0.59 -0.1,-1.13 -0.2,-1.72 m 0.3,2.35 c 0,0.43 0.1,0.85 0.1,1.28 0,-0.44 -0.1,-0.84 -0.1,-1.28 m 0.2,2 c 0.1,0.5 0.1,1.02 0.2,1.51 -0.1,-0.49 -0.1,-1.01 -0.2,-1.51 m 0.3,2.34 c 0,0.43 0.1,0.86 0.1,1.29 0,-0.44 -0.1,-0.85 -0.1,-1.29 m 0.2,2.08 c 0.1,0.45 0.1,0.92 0.2,1.37 -0.1,-0.47 -0.1,-0.9 -0.2,-1.37 m 0.2,1.86 c 0.1,0.59 0.2,1.18 0.2,1.77 0,-0.59 -0.1,-1.17 -0.2,-1.77 m 0.3,2.49 c 0,0.45 0.1,0.92 0.1,1.38 0,-0.47 -0.1,-0.92 -0.1,-1.38 m 0.2,1.9 c 0.1,0.61 0.1,1.22 0.2,1.83 -0.1,-0.6 -0.1,-1.24 -0.2,-1.83 m 0.2,2.43 c 0.1,0.46 0.1,0.92 0.2,1.37 -0.1,-0.44 -0.1,-0.93 -0.2,-1.37 m 0.2,1.99 c 0.1,0.61 0.2,1.19 0.2,1.8 0,-0.59 -0.1,-1.21 -0.2,-1.8 m 0.3,2.36 c 0,0.47 0.1,0.94 0.1,1.42 0,-0.47 -0.1,-0.95 -0.1,-1.42 m 0.2,2.03 c 0,0.61 0.1,1.21 0.1,1.82 0,-0.59 -0.1,-1.22 -0.1,-1.82 m 0.2,2.3 c 0,0.48 0.1,1.01 0.1,1.49 0,-0.5 -0.1,-0.99 -0.1,-1.49 m 0.2,2.09 c 0,0.54 0.1,1.11 0.1,1.65 0,-0.56 -0.1,-1.09 -0.1,-1.65 m 0.1,1.98 c 0.1,0.62 0.1,1.2 0.2,1.82 -0.1,-0.63 -0.1,-1.19 -0.2,-1.82 m 0.2,2.46 c 0.1,0.47 0.1,0.94 0.2,1.42 -0.1,-0.5 -0.1,-0.92 -0.2,-1.42 m 0.2,1.95 c 0.1,0.59 0.1,1.22 0.2,1.81 -0.1,-0.6 -0.1,-1.22 -0.2,-1.81 m 0.2,2.45 c 0,0.45 0.1,0.95 0.1,1.41 0,-0.47 -0.1,-0.94 -0.1,-1.41 m 0.2,1.97 c 0,0.61 0.1,1.25 0.1,1.86 0,-0.63 -0.1,-1.23 -0.1,-1.86 m 0.1,2.38 c 0.1,0.46 0.1,0.94 0.2,1.4 -0.1,-0.47 -0.1,-0.92 -0.2,-1.4 m 0.2,2.07 c 0,0.6 0.1,1.22 0.1,1.82 0,-0.6 -0.1,-1.22 -0.1,-1.82 m 0.2,2.31 c 0,0.5 0,0.97 0.1,1.47 -0.1,-0.47 -0.1,-1 -0.1,-1.47 m 0.1,2.13 c 0.1,0.57 0.1,1.19 0.1,1.76 0,-0.6 0,-1.16 -0.1,-1.76 m 0.2,2 c 0,0.59 0,1.2 0.1,1.8 -0.1,-0.6 -0.1,-1.2 -0.1,-1.8 m 0.1,2.37 c 0,0.55 0.1,1.11 0.1,1.66 0,-0.57 -0.1,-1.09 -0.1,-1.66 m 0.1,1.97 c 0.1,0.65 0.1,1.28 0.1,1.92 0,-0.64 0,-1.28 -0.1,-1.92 m 0.2,2.48 c 0,0.5 0,0.99 0.1,1.49 -0.1,-0.5 -0.1,-0.99 -0.1,-1.49 m 0.1,1.99 c 0,0.61 0.1,1.25 0.1,1.87 0,-0.63 -0.1,-1.24 -0.1,-1.87 m 0.1,2.43 c 0.1,0.49 0.1,0.99 0.1,1.47 0,-0.47 0,-0.99 -0.1,-1.47 m 0.1,2.03 c 0.1,0.65 0.1,1.28 0.1,1.92 0,-0.64 0,-1.28 -0.1,-1.92 m 0.2,2.25 c 0,0.55 0,1.11 0,1.66 0,-0.54 0,-1.12 0,-1.66 m 0.1,2.18 c 0,0.64 0,1.27 0.1,1.91 -0.1,-0.63 -0.1,-1.28 -0.1,-1.91 m 0.1,2.22 c 0,0.57 0,1.11 0,1.69 0,-0.57 0,-1.12 0,-1.69 m 0.1,2.26 c 0,0.57 0,1.12 0,1.69 0,-0.57 0,-1.12 0,-1.69 m 0.1,1.97 c 0,0.62 0,1.28 0,1.9 0,-0.63 0,-1.27 0,-1.9 m 0,2.48 c 0.1,0.51 0.1,1.03 0.1,1.54 0,-0.51 0,-1.03 -0.1,-1.54 m 0.1,2.02 c 0,0.62 0.1,1.26 0.1,1.88 0,-0.61 -0.1,-1.28 -0.1,-1.88 m 0.1,2.44 c 0,0.51 0,0.98 0.1,1.49 -0.1,-0.51 -0.1,-0.98 -0.1,-1.49 m 0.1,2.03 c 0,0.62 0,1.27 0,1.89 0,-0.63 0,-1.26 0,-1.89 m 0.1,2.38 c 0,0.51 0,1 0,1.51 0,-0.51 0,-1 0,-1.51 m 0,2.12 c 0,0.65 0,1.29 0.1,1.93 -0.1,-0.63 -0.1,-1.29 -0.1,-1.93 m 0.1,2.07 c 0,0.6 0,1.22 0,1.82 0,-0.61 0,-1.21 0,-1.82 m 0,2.39 c 0,0.58 0,1.18 0.1,1.75 -0.1,-0.6 -0.1,-1.15 -0.1,-1.75 m 0.1,1.98 c 0,0.62 0,1.29 0,1.92 0,-0.64 0,-1.28 0,-1.92 m 0,2.51 c 0,0.53 0,1.09 0,1.62 0,-0.54 0,-1.08 0,-1.62 m 0,1.98 c 0.1,0.64 0.1,1.28 0.1,1.93 0,-0.64 0,-1.29 -0.1,-1.93 m 0.1,2.45 c 0,0.53 0,1.09 0,1.62 0,-0.54 0,-1.08 0,-1.62 m 0,2.05 c 0,0.65 0,1.31 0,1.96 0,-0.64 0,-1.32 0,-1.96 m 0,2.36 c 0,0.56 0,1.13 0,1.69 0,-0.58 0,-1.11 0,-1.69 m 0.1,2.11 c 0,0.68 0,1.32 0,2 0,-0.68 0,-1.32 0,-2 m 0,2.3 c 0,0.58 0,1.12 0,1.7 0,-0.58 0,-1.12 0,-1.7 m 0,2.26 c 0,0.65 0,1.31 0,1.96 0,-0.64 0,-1.32 0,-1.96 m 0,1.96 h -0.3 l 0.3,610.42 c 0,-0.67 0,-1.38 0,-2.05 v -608.37 0",
    id: "path434"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,10645.2,98.8499)",
    spreadMethod: "pad",
    id: "linearGradient448"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4494c5"
    },
    offset: 0,
    id: "stop438"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5651ac"
    },
    offset: 0.2513,
    id: "stop440"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#622688"
    },
    offset: 0.5005,
    id: "stop442"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#6b216b"
    },
    offset: 0.7304,
    id: "stop444"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#a11b67"
    },
    offset: 1,
    id: "stop446"
  })), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath458"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 17492.8,628.391 c -173.1,0 -313.4,140.308 -313.4,313.39 l -6.4,1254.269 c 0,173.08 -140.3,313.4 -313.4,313.4 -173,0 -313.4,-140.32 -313.4,-313.4 l -11.3,-1254.269 c 0,-173.082 -140.3,-313.39 -313.4,-313.39 -173,0 -313.4,140.308 -313.4,313.39 0,0 -0.6,1283.229 0,1297.599 -21.1,152.52 -158,270.07 -316.3,270.07 -173.1,0 -316.3,-140.32 -316.3,-313.4 v -5.3 c -0.6,284.04 -125.6,538.87 -323.4,712.91 168.6,151.91 391.9,244.34 636.8,244.34 241.8,0 462.5,-90.37 630.4,-238.97 168,148.6 388.6,238.97 630.5,238.97 525.7,0 951.9,-426.2 951.9,-951.95 l 4.5,-1254.269 c 0,-173.082 -140.4,-313.39 -313.4,-313.39 m -2763.7,90.461 v 0 c 253.2,119.41 445.3,347.158 516.4,623.478 -71.1,-276.31 -263.2,-504.068 -516.4,-623.478 m 516.4,623.668 c 0.4,1.39 0.7,2.79 1.1,4.19 -0.4,-1.41 -0.7,-2.8 -1.1,-4.19 m 1.1,4.19 c 0.5,1.91 0.9,3.79 1.4,5.7 -0.5,-1.9 -0.9,-3.8 -1.4,-5.7 m 1.4,5.78 c 0.4,1.41 0.7,2.8 1.1,4.2 -0.4,-1.4 -0.7,-2.79 -1.1,-4.2 m 1.1,4.3 c 0.3,1.38 0.6,2.76 1,4.13 -0.4,-1.36 -0.7,-2.76 -1,-4.13 m 1,4.36 c 0.3,1.32 0.6,2.64 0.9,3.96 -0.3,-1.3 -0.6,-2.65 -0.9,-3.96 m 1,4.37 c 0.3,1.29 0.6,2.62 0.9,3.91 -0.3,-1.3 -0.6,-2.61 -0.9,-3.91 m 1,4.26 c 0.1,0.42 0.2,0.83 0.3,1.25 -0.1,-0.41 -0.2,-0.84 -0.3,-1.25 m 0.4,1.54 c 0.1,0.87 0.3,1.68 0.5,2.55 -0.2,-0.85 -0.4,-1.7 -0.5,-2.55 m 0.6,2.72 c 0.1,0.42 0.1,0.83 0.2,1.25 -0.1,-0.41 -0.2,-0.84 -0.2,-1.25 m 0.3,1.69 c 0.3,1.29 0.6,2.55 0.9,3.84 -0.3,-1.28 -0.6,-2.55 -0.9,-3.84 m 1,4.29 c 0.2,1.27 0.5,2.53 0.8,3.8 -0.3,-1.27 -0.6,-2.53 -0.8,-3.8 m 0.9,4.35 c 0.1,0.36 0.1,0.79 0.2,1.15 -0.1,-0.39 -0.1,-0.75 -0.2,-1.15 m 0.3,1.71 c 0.2,0.64 0.3,1.28 0.4,1.92 -0.1,-0.64 -0.2,-1.28 -0.4,-1.92 m 0.6,2.64 c 0.1,0.36 0.1,0.74 0.2,1.1 -0.1,-0.37 -0.1,-0.73 -0.2,-1.1 m 0.3,1.64 c 0.1,0.67 0.3,1.4 0.4,2.07 -0.1,-0.7 -0.2,-1.37 -0.4,-2.07 m 0.5,2.61 c 0.1,0.36 0.2,0.74 0.3,1.1 -0.1,-0.37 -0.2,-0.73 -0.3,-1.1 m 0.4,1.82 c 0.1,0.61 0.2,1.22 0.4,1.83 -0.2,-0.6 -0.3,-1.23 -0.4,-1.83 m 0.5,2.51 c 0.1,0.36 0.1,0.72 0.2,1.09 -0.1,-0.36 -0.1,-0.74 -0.2,-1.09 m 0.3,1.78 c 0.1,0.36 0.2,0.68 0.2,1.04 0,-0.33 -0.1,-0.71 -0.2,-1.04 m 0.5,2.51 c 0.1,0.37 0.2,0.73 0.2,1.1 0,-0.36 -0.1,-0.75 -0.2,-1.1 m 0.4,1.77 c 0,0.4 0.1,0.74 0.2,1.14 -0.1,-0.4 -0.2,-0.74 -0.2,-1.14 m 0.2,1.3 c 0.1,0.79 0.3,1.59 0.4,2.38 -0.1,-0.79 -0.3,-1.58 -0.4,-2.38 m 0.6,3.01 c 0,0.36 0.1,0.74 0.2,1.1 -0.1,-0.37 -0.2,-0.73 -0.2,-1.1 m 0.3,1.74 c 0.1,0.61 0.2,1.22 0.3,1.83 -0.1,-0.6 -0.2,-1.23 -0.3,-1.83 m 0.4,2.65 c 0.1,0.33 0.2,0.67 0.2,1.01 0,-0.33 -0.1,-0.68 -0.2,-1.01 m 0.4,1.76 c 0.1,0.55 0.2,1.15 0.3,1.7 -0.1,-0.57 -0.2,-1.13 -0.3,-1.7 m 0.4,2.55 c 0.1,0.31 0.1,0.66 0.2,0.97 -0.1,-0.31 -0.1,-0.66 -0.2,-0.97 m 0.3,1.84 c 0.1,0.46 0.2,0.95 0.3,1.41 -0.1,-0.49 -0.2,-0.93 -0.3,-1.41 m 0.4,2.5 c 0.1,0.3 0.2,0.65 0.2,0.96 0,-0.31 -0.1,-0.65 -0.2,-0.96 m 0.4,1.82 c 0,0.31 0.1,0.65 0.1,0.96 0,-0.34 -0.1,-0.63 -0.1,-0.96 m 0.4,2.51 c 0,0.31 0.1,0.61 0.1,0.92 0,-0.31 -0.1,-0.61 -0.1,-0.92 m 0.3,1.84 c 0,0.31 0.1,0.65 0.1,0.95 0,-0.31 -0.1,-0.64 -0.1,-0.95 m 0.3,2.18 c 0.1,0.37 0.1,0.75 0.2,1.12 -0.1,-0.38 -0.1,-0.75 -0.2,-1.12 m 0.4,2.17 c 0,0.31 0.1,0.61 0.1,0.91 0,-0.31 -0.1,-0.6 -0.1,-0.91 m 0.3,1.96 c 0,0.43 0.1,0.8 0.2,1.24 -0.1,-0.43 -0.2,-0.82 -0.2,-1.24 m 0.3,2.42 c 0.1,0.28 0.1,0.58 0.2,0.86 -0.1,-0.29 -0.1,-0.57 -0.2,-0.86 m 0.3,1.88 c 0.1,0.34 0.1,0.71 0.2,1.05 -0.1,-0.34 -0.1,-0.71 -0.2,-1.05 m 0.4,2.39 c 0,0.34 0.1,0.66 0.1,1 0,-0.33 -0.1,-0.67 -0.1,-1 m 0.3,1.88 c 0,0.34 0,0.61 0.1,0.95 -0.1,-0.33 -0.1,-0.62 -0.1,-0.95 m 0.3,2.5 c 0.1,0.31 0.1,0.62 0.2,0.93 -0.1,-0.31 -0.1,-0.61 -0.2,-0.93 m 0.3,1.92 c 0,0.28 0.1,0.55 0.1,0.82 0,-0.29 -0.1,-0.53 -0.1,-0.82 m 0.3,2.21 c 0.1,0.37 0.1,0.74 0.2,1.11 -0.1,-0.38 -0.1,-0.73 -0.2,-1.11 m 0.3,2.13 c 0,0.27 0.1,0.61 0.1,0.89 0,-0.3 -0.1,-0.6 -0.1,-0.89 m 0.3,2.11 c 0,0.34 0.1,0.68 0.1,1.02 0,-0.34 -0.1,-0.69 -0.1,-1.02 m 0.3,2.28 c 0,0.28 0.1,0.55 0.1,0.83 0,-0.27 -0.1,-0.56 -0.1,-0.83 m 0.2,1.98 c 0.1,0.28 0.1,0.55 0.1,0.83 0,-0.27 0,-0.56 -0.1,-0.83 m 0.4,2.44 c 0,0.22 0,0.49 0,0.71 0,-0.22 0,-0.48 0,-0.71 m 0.2,1.97 c 0,0.22 0.1,0.44 0.1,0.66 0,-0.23 -0.1,-0.43 -0.1,-0.66 m 0.3,2.4 c 0,0.25 0.1,0.45 0.1,0.69 0,-0.22 -0.1,-0.46 -0.1,-0.69 m 0.2,1.91 c 0.1,0.25 0.1,0.51 0.1,0.76 0,-0.25 0,-0.51 -0.1,-0.76 m 0.3,2.48 c 0,0.19 0.1,0.44 0.1,0.63 0,-0.2 -0.1,-0.42 -0.1,-0.63 m 0.2,1.91 c 0.1,0.25 0.1,0.47 0.1,0.72 0,-0.25 0,-0.48 -0.1,-0.72 m 0.3,2.23 c 0,0.29 0.1,0.55 0.1,0.83 0,-0.27 -0.1,-0.55 -0.1,-0.83 m 0.2,2.12 c 0.1,0.25 0.1,0.54 0.1,0.79 0,-0.27 0,-0.52 -0.1,-0.79 m 0.3,2.16 c 0,0.15 0,0.34 0,0.49 0,-0.15 0,-0.33 0,-0.49 m 0.2,2.26 c 0,0.22 0.1,0.5 0.1,0.72 0,-0.25 -0.1,-0.47 -0.1,-0.72 m 0.2,2.1 c 0.1,0.18 0.1,0.33 0.1,0.52 0,-0.18 0,-0.34 -0.1,-0.52 m 0.3,2.35 c 0,0.22 0,0.38 0,0.6 0,-0.2 0,-0.4 0,-0.6 m 0.2,1.97 c 0,0.22 0,0.4 0,0.62 0,-0.21 0,-0.42 0,-0.62 m 0.2,2.42 c 0,0.19 0,0.37 0.1,0.56 -0.1,-0.18 -0.1,-0.38 -0.1,-0.56 m 0.2,1.98 c 0,0.22 0,0.39 0.1,0.61 -0.1,-0.2 -0.1,-0.41 -0.1,-0.61 m 0.2,2.43 c 0,0.16 0.1,0.32 0.1,0.48 0,-0.16 -0.1,-0.32 -0.1,-0.48 m 0.2,1.97 c 0,0.19 0,0.41 0.1,0.6 -0.1,-0.21 -0.1,-0.39 -0.1,-0.6 m 0.2,2.25 c 0,0.1 0,0.24 0,0.33 0,-0.11 0,-0.22 0,-0.33 m 0.2,2.15 c 0,0.19 0,0.45 0,0.64 0,-0.21 0,-0.44 0,-0.64 m 0.2,2.06 c 0,0.16 0,0.37 0,0.53 0,-0.19 0,-0.35 0,-0.53 m 0.2,2.34 c 0,0.22 0,0.42 0,0.64 0,-0.23 0,-0.41 0,-0.64 m 0.1,2.05 c 0,0.19 0.1,0.37 0.1,0.56 -0.1,-0.21 -0.1,-0.36 -0.1,-0.56 m 0.2,2.42 c 0,0.16 0,0.37 0,0.52 0,-0.18 0,-0.34 0,-0.52 m 0.2,1.92 c 0,0.22 0,0.45 0,0.67 0,-0.22 0,-0.44 0,-0.67 m 0.1,2.49 c 0,0.19 0.1,0.3 0.1,0.49 0,-0.16 -0.1,-0.33 -0.1,-0.49 m 0.2,1.96 c 0,0.22 0,0.44 0,0.66 0,-0.23 0,-0.43 0,-0.66 m 0.1,2.42 c 0,0.07 0,0.18 0.1,0.24 -0.1,-0.09 -0.1,-0.15 -0.1,-0.24 m 0.2,2.04 c 0,0.19 0,0.38 0,0.57 0,-0.18 0,-0.39 0,-0.57 m 0.1,2.23 c 0,0.1 0,0.22 0,0.31 0,-0.11 0,-0.2 0,-0.31 m 0.1,2.23 c 0.1,0.19 0.1,0.37 0.1,0.56 0,-0.19 0,-0.38 -0.1,-0.56 m 0.2,2.05 c 0,0.16 0,0.34 0,0.5 0,-0.16 0,-0.34 0,-0.5 m 0.1,2.37 c 0,0.19 0,0.38 0,0.56 0,-0.2 0,-0.35 0,-0.56 m 0.1,2.03 c 0,0.19 0,0.37 0,0.56 0,-0.18 0,-0.38 0,-0.56 m 0.1,2.48 c 0,0.13 0.1,0.2 0.1,0.33 0,-0.11 -0.1,-0.22 -0.1,-0.33 m 0.1,1.99 c 0,0.19 0.1,0.33 0.1,0.52 0,-0.16 -0.1,-0.36 -0.1,-0.52 m 0.2,2.43 c 0,0.1 0,0.21 0,0.31 0,-0.1 0,-0.21 0,-0.31 m 0,2 c 0.1,0.19 0.1,0.38 0.1,0.57 0,-0.19 0,-0.39 -0.1,-0.57 m 0.1,2.26 c 0,0.07 0,0.21 0.1,0.28 -0.1,-0.1 -0.1,-0.18 -0.1,-0.28 m 0.1,2.18 c 0,0.23 0,0.36 0,0.58 0,-0.2 0,-0.37 0,-0.58 m 0.1,2.12 c 0,0.15 0,0.32 0,0.48 0,-0.16 0,-0.32 0,-0.48 m 0.1,2.36 c 0,0.19 0,0.37 0,0.56 0,-0.18 0,-0.38 0,-0.56 m 0.1,2.05 c 0,0.15 0,0.38 0,0.54 0,-0.19 0,-0.36 0,-0.54 m 0,2.43 c 0,0.16 0,0.33 0.1,0.49 -0.1,-0.16 -0.1,-0.32 -0.1,-0.49 m 0.1,2 c 0,0.22 0,0.39 0,0.61 0,-0.21 0,-0.4 0,-0.61 m 0.1,2.54 c 0,0.04 0,0.11 0,0.14 0,-0.04 0,-0.09 0,-0.14 m 0,1.96 c 0,0.19 0,0.38 0,0.57 0,-0.19 0,-0.39 0,-0.57 m 0.1,2.32 c 0,0.07 0,0.17 0,0.23 0,-0.09 0,-0.13 0,-0.23 m 0,2.15 c 0,0.19 0,0.4 0,0.59 0,-0.21 0,-0.38 0,-0.59 m 0,2.21 c 0,0.13 0,0.23 0,0.36 0,-0.12 0,-0.24 0,-0.36 m 0.1,2.29 c 0,0.16 0,0.36 0,0.52 0,-0.19 0,-0.33 0,-0.52 m 0,2.14 c 0,0.16 0,0.27 0,0.43 0,-0.14 0,-0.29 0,-0.43 m 0,2.39 c 0,0.13 0,0.28 0,0.4 0,-0.14 0,-0.26 0,-0.4 m 0,2.09 c 0,0.13 0,0.29 0.1,0.42 -0.1,-0.14 -0.1,-0.28 -0.1,-0.42 m 0.1,2.42 c 0,0.09 0,0.21 0,0.3 0,-0.09 0,-0.21 0,-0.3 m 0,2 c 0,0.19 0,0.36 0,0.56 0,-0.19 0,-0.37 0,-0.56",
    id: "path456"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6528.71,3169.39,3169.39,-6528.71,11052.6,-740.38)",
    spreadMethod: "pad",
    id: "linearGradient470"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4494c5"
    },
    offset: 0,
    id: "stop460"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5651ac"
    },
    offset: 0.2513,
    id: "stop462"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#622688"
    },
    offset: 0.5005,
    id: "stop464"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#6b216b"
    },
    offset: 0.7304,
    id: "stop466"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#a11b67"
    },
    offset: 1,
    id: "stop468"
  })), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath480"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14729.1,718.852 c -54.4,56.367 -92.2,138.429 -92.2,222.929 V 2196.05 c 0,280.88 121.7,533.36 315.2,707.61 197.8,-174.04 322.8,-428.87 323.4,-712.91 l -0.3,-610.42 h 0.3 v 0 c 0,-0.65 0,-1.31 0,-1.96 0,-0.2 0,-0.37 0,-0.56 0,-0.58 0,-1.12 0,-1.7 0,-0.09 0,-0.21 0,-0.3 0,-0.68 0,-1.32 0,-2 -0.1,-0.13 -0.1,-0.29 -0.1,-0.42 0,-0.56 0,-1.13 0,-1.69 0,-0.12 0,-0.27 0,-0.4 0,-0.65 0,-1.31 0,-1.96 0,-0.16 0,-0.27 0,-0.43 0,-0.53 0,-1.09 0,-1.62 0,-0.16 0,-0.36 0,-0.52 0,-0.65 0,-1.29 -0.1,-1.93 0,-0.13 0,-0.23 0,-0.36 0,-0.53 0,-1.09 0,-1.62 0,-0.19 0,-0.4 0,-0.59 0,-0.63 0,-1.3 0,-1.92 0,-0.06 0,-0.16 0,-0.23 -0.1,-0.57 -0.1,-1.17 -0.1,-1.75 0,-0.19 0,-0.38 0,-0.57 0,-0.6 0,-1.22 0,-1.82 0,-0.03 0,-0.1 0,-0.14 -0.1,-0.64 -0.1,-1.28 -0.1,-1.93 0,-0.22 0,-0.39 0,-0.61 0,-0.51 0,-1 0,-1.51 -0.1,-0.16 -0.1,-0.33 -0.1,-0.49 0,-0.62 0,-1.27 0,-1.89 0,-0.16 0,-0.39 0,-0.54 -0.1,-0.51 -0.1,-0.98 -0.1,-1.49 0,-0.19 0,-0.37 0,-0.56 0,-0.62 -0.1,-1.26 -0.1,-1.88 0,-0.16 0,-0.33 0,-0.48 0,-0.51 0,-1.03 -0.1,-1.54 0,-0.22 0,-0.35 0,-0.58 0,-0.62 0,-1.28 0,-1.9 -0.1,-0.07 -0.1,-0.21 -0.1,-0.28 0,-0.57 0,-1.12 0,-1.69 0,-0.19 0,-0.38 -0.1,-0.57 0,-0.58 0,-1.12 0,-1.69 0,-0.1 0,-0.21 0,-0.31 -0.1,-0.64 -0.1,-1.27 -0.1,-1.91 0,-0.19 -0.1,-0.33 -0.1,-0.52 0,-0.55 0,-1.11 0,-1.66 0,-0.13 -0.1,-0.2 -0.1,-0.33 0,-0.64 0,-1.27 -0.1,-1.92 0,-0.19 0,-0.37 0,-0.56 0,-0.48 0,-0.98 -0.1,-1.47 0,-0.18 0,-0.37 0,-0.56 0,-0.62 -0.1,-1.26 -0.1,-1.87 0,-0.16 0,-0.34 0,-0.5 -0.1,-0.5 -0.1,-0.99 -0.1,-1.49 0,-0.19 0,-0.37 -0.1,-0.56 0,-0.64 0,-1.27 -0.1,-1.92 0,-0.09 0,-0.21 0,-0.31 0,-0.55 -0.1,-1.11 -0.1,-1.66 0,-0.19 0,-0.38 0,-0.57 -0.1,-0.6 -0.1,-1.21 -0.1,-1.8 -0.1,-0.06 -0.1,-0.17 -0.1,-0.24 0,-0.57 0,-1.19 -0.1,-1.76 0,-0.22 0,-0.44 0,-0.66 -0.1,-0.5 -0.1,-0.97 -0.1,-1.47 0,-0.19 -0.1,-0.3 -0.1,-0.49 0,-0.6 -0.1,-1.22 -0.1,-1.82 0,-0.22 0,-0.45 0,-0.67 -0.1,-0.46 -0.1,-0.94 -0.2,-1.4 0,-0.15 0,-0.36 0,-0.52 0,-0.61 -0.1,-1.25 -0.1,-1.86 0,-0.19 -0.1,-0.37 -0.1,-0.56 0,-0.46 -0.1,-0.96 -0.1,-1.41 0,-0.22 0,-0.42 0,-0.64 -0.1,-0.59 -0.1,-1.22 -0.2,-1.81 0,-0.16 0,-0.37 0,-0.53 -0.1,-0.48 -0.1,-0.95 -0.2,-1.42 0,-0.19 0,-0.45 0,-0.64 -0.1,-0.62 -0.1,-1.2 -0.2,-1.82 0,-0.09 0,-0.23 0,-0.33 0,-0.54 -0.1,-1.11 -0.1,-1.65 -0.1,-0.19 -0.1,-0.41 -0.1,-0.6 0,-0.48 -0.1,-1.01 -0.1,-1.49 0,-0.16 -0.1,-0.32 -0.1,-0.48 0,-0.61 -0.1,-1.21 -0.1,-1.82 -0.1,-0.22 -0.1,-0.39 -0.1,-0.61 0,-0.48 -0.1,-0.95 -0.1,-1.42 -0.1,-0.19 -0.1,-0.37 -0.1,-0.56 0,-0.61 -0.1,-1.19 -0.2,-1.8 0,-0.22 0,-0.4 0,-0.62 -0.1,-0.45 -0.1,-0.91 -0.2,-1.37 0,-0.22 0,-0.38 0,-0.6 -0.1,-0.61 -0.1,-1.22 -0.2,-1.83 0,-0.19 0,-0.34 -0.1,-0.52 0,-0.46 -0.1,-0.93 -0.1,-1.38 0,-0.22 -0.1,-0.5 -0.1,-0.72 0,-0.59 -0.1,-1.18 -0.2,-1.77 0,-0.15 0,-0.34 0,-0.49 -0.1,-0.45 -0.1,-0.92 -0.2,-1.37 0,-0.25 0,-0.54 -0.1,-0.79 0,-0.43 -0.1,-0.86 -0.1,-1.29 0,-0.28 -0.1,-0.54 -0.1,-0.83 -0.1,-0.49 -0.1,-1.01 -0.2,-1.51 0,-0.25 0,-0.47 -0.1,-0.72 0,-0.43 -0.1,-0.85 -0.1,-1.28 0,-0.19 -0.1,-0.44 -0.1,-0.63 0,-0.58 -0.1,-1.14 -0.2,-1.72 0,-0.25 0,-0.51 -0.1,-0.76 0,-0.4 -0.1,-0.81 -0.1,-1.22 0,-0.24 -0.1,-0.44 -0.1,-0.69 -0.1,-0.58 -0.1,-1.16 -0.2,-1.74 0,-0.22 -0.1,-0.44 -0.1,-0.66 -0.1,-0.43 -0.1,-0.83 -0.2,-1.26 0,-0.22 0,-0.49 0,-0.71 -0.1,-0.54 -0.2,-1.07 -0.3,-1.61 0,-0.28 0,-0.55 -0.1,-0.83 0,-0.4 -0.1,-0.75 -0.1,-1.15 0,-0.28 -0.1,-0.55 -0.1,-0.83 -0.1,-0.43 -0.1,-0.83 -0.2,-1.26 0,-0.34 -0.1,-0.68 -0.1,-1.02 -0.1,-0.41 -0.1,-0.82 -0.2,-1.22 0,-0.28 -0.1,-0.62 -0.1,-0.89 -0.1,-0.34 -0.1,-0.69 -0.1,-1.02 -0.1,-0.37 -0.1,-0.74 -0.2,-1.11 -0.1,-0.45 -0.1,-0.94 -0.2,-1.39 0,-0.27 -0.1,-0.54 -0.1,-0.82 -0.1,-0.32 -0.1,-0.68 -0.1,-0.99 -0.1,-0.31 -0.1,-0.62 -0.2,-0.93 -0.1,-0.51 -0.1,-1.03 -0.2,-1.55 -0.1,-0.34 -0.1,-0.61 -0.1,-0.95 -0.1,-0.29 -0.1,-0.59 -0.2,-0.88 0,-0.34 -0.1,-0.66 -0.1,-1 -0.1,-0.45 -0.2,-0.9 -0.2,-1.34 -0.1,-0.34 -0.1,-0.71 -0.2,-1.05 0,-0.35 -0.1,-0.67 -0.1,-1.02 -0.1,-0.28 -0.1,-0.58 -0.2,-0.86 0,-0.38 -0.1,-0.81 -0.1,-1.18 -0.1,-0.44 -0.2,-0.81 -0.2,-1.24 -0.1,-0.34 -0.1,-0.71 -0.2,-1.05 0,-0.3 -0.1,-0.6 -0.1,-0.91 -0.1,-0.35 -0.1,-0.69 -0.2,-1.05 -0.1,-0.37 -0.1,-0.75 -0.2,-1.12 0,-0.4 -0.1,-0.83 -0.2,-1.23 0,-0.3 -0.1,-0.64 -0.1,-0.95 -0.1,-0.31 -0.1,-0.61 -0.2,-0.92 0,-0.31 -0.1,-0.61 -0.1,-0.92 -0.1,-0.51 -0.2,-1.04 -0.3,-1.55 0,-0.31 -0.1,-0.65 -0.1,-0.96 -0.1,-0.29 -0.1,-0.57 -0.2,-0.86 0,-0.31 -0.1,-0.66 -0.2,-0.96 0,-0.36 -0.1,-0.74 -0.1,-1.09 -0.1,-0.46 -0.2,-0.95 -0.3,-1.41 0,-0.29 -0.1,-0.58 -0.1,-0.87 -0.1,-0.31 -0.1,-0.66 -0.2,-0.97 0,-0.29 -0.1,-0.56 -0.1,-0.85 -0.1,-0.55 -0.2,-1.15 -0.3,-1.7 -0.1,-0.24 -0.1,-0.51 -0.2,-0.75 0,-0.34 -0.1,-0.68 -0.2,-1.01 0,-0.29 0,-0.54 -0.1,-0.82 -0.1,-0.61 -0.2,-1.22 -0.3,-1.83 -0.1,-0.22 -0.1,-0.41 -0.1,-0.64 -0.1,-0.36 -0.2,-0.74 -0.2,-1.1 -0.1,-0.2 -0.1,-0.43 -0.2,-0.63 -0.1,-0.79 -0.3,-1.59 -0.4,-2.38 0,-0.04 0,-0.12 0,-0.16 -0.1,-0.4 -0.2,-0.74 -0.2,-1.14 -0.1,-0.22 -0.1,-0.45 -0.2,-0.67 0,-0.37 -0.1,-0.73 -0.2,-1.1 -0.1,-0.5 -0.2,-0.96 -0.3,-1.47 0,-0.36 -0.1,-0.68 -0.2,-1.04 0,-0.24 0,-0.45 -0.1,-0.69 -0.1,-0.37 -0.1,-0.73 -0.2,-1.09 -0.1,-0.24 -0.1,-0.44 -0.1,-0.68 -0.2,-0.61 -0.3,-1.22 -0.4,-1.83 0,-0.24 -0.1,-0.48 -0.1,-0.72 -0.1,-0.36 -0.2,-0.74 -0.3,-1.1 0,-0.18 0,-0.36 -0.1,-0.54 -0.1,-0.67 -0.3,-1.4 -0.4,-2.07 0,-0.17 -0.1,-0.36 -0.1,-0.54 -0.1,-0.36 -0.1,-0.74 -0.2,-1.1 -0.1,-0.24 -0.1,-0.48 -0.2,-0.72 -0.1,-0.64 -0.2,-1.28 -0.4,-1.92 0,-0.17 0,-0.38 -0.1,-0.56 -0.1,-0.36 -0.1,-0.79 -0.2,-1.15 -0.1,-0.17 -0.1,-0.37 -0.1,-0.55 -0.3,-1.27 -0.6,-2.53 -0.8,-3.8 -0.1,-0.15 -0.1,-0.29 -0.1,-0.45 -0.3,-1.29 -0.6,-2.55 -0.9,-3.84 0,-0.15 0,-0.29 -0.1,-0.44 -0.1,-0.42 -0.1,-0.83 -0.2,-1.25 -0.1,-0.05 -0.1,-0.13 -0.1,-0.17 -0.2,-0.87 -0.4,-1.68 -0.5,-2.55 -0.1,-0.11 -0.1,-0.18 -0.1,-0.29 -0.1,-0.42 -0.2,-0.83 -0.3,-1.25 0,-0.11 0,-0.24 -0.1,-0.35 -0.3,-1.29 -0.6,-2.62 -0.9,-3.91 0,-0.16 0,-0.26 -0.1,-0.41 -0.3,-1.32 -0.6,-2.64 -0.9,-3.96 0,-0.08 0,-0.14 0,-0.23 -0.4,-1.37 -0.7,-2.75 -1,-4.13 0,-0.04 0,-0.06 0,-0.1 -0.4,-1.4 -0.7,-2.79 -1.1,-4.2 0,-0.02 0,-0.06 0,-0.08 -0.5,-1.91 -0.9,-3.79 -1.4,-5.7 v 0 c -0.4,-1.4 -0.7,-2.8 -1.1,-4.19 0,-0.07 0,-0.13 0,-0.19 -71.1,-276.32 -263.2,-504.068 -516.4,-623.478",
    id: "path478"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.925925, 0, 0, -2, -722.223083, 679.600098)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g56",
    clipPath: "url(#clipPath60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 10840.9,0 v 360.77 h 256.6 v -24.731 h -229.8 V 194.281 h 206.6 v -24.73 h -206.6 V 24.7305 h 232.4 V 0 h -259.2",
    style: {
      fill: "url(#linearGradient72)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g78",
    clipPath: "url(#clipPath82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11671.9,0 -254.1,320.582 V 0 h -25.7 v 360.77 h 25.2 l 249,-313.8481 V 360.77 h 25.7 V 0 h -20.1",
    style: {
      fill: "url(#linearGradient94)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g100",
    clipPath: "url(#clipPath104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12131.9,336.039 V 0 h -26.8 v 336.039 h -125.8 v 24.731 h 278.3 v -24.731 h -125.7",
    style: {
      fill: "url(#linearGradient116)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g122",
    clipPath: "url(#clipPath126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 12545,0 v 360.77 h 256.6 v -24.731 h -229.8 V 194.281 h 206.6 v -24.73 h -206.6 V 24.7305 h 232.4 V 0 H 12545",
    style: {
      fill: "url(#linearGradient138)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g142",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g144",
    clipPath: "url(#clipPath148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13349.7,257.191 c 0,48.45 -38.1,78.848 -103.6,78.848 H 13123 v -162.34 h 121.6 c 60.3,0 105.1,30.41 105.1,82.442 z M 13355.9,0 13241,149.461 h -118 V 0 h -26.8 v 360.77 h 151.5 c 77.8,0 128.8,-42.29 128.8,-102.579 v -1 c 0,-60.332 -44.8,-94.851 -105.6,-103.101 L 13389.9,0 h -34",
    style: {
      fill: "url(#linearGradient160)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g164",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g166",
    clipPath: "url(#clipPath170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13796.3,336.039 V 0 h -26.8 v 336.039 h -125.8 v 24.731 h 278.3 v -24.731 h -125.7",
    style: {
      fill: "url(#linearGradient182)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path184"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g186",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g188",
    clipPath: "url(#clipPath192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14312.5,333.949 -95.4,-208.699 h 190.2 z M 14464.5,0 l -45.9,101.012 h -212.8 L 14159.9,0 h -27.8 l 168,363.352 h 25.8 L 14493.9,0 h -29.4",
    style: {
      fill: "url(#linearGradient204)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path206"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g208",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g210",
    clipPath: "url(#clipPath214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14779.7,0 v 360.77 h 26.8 V 0 h -26.8",
    style: {
      fill: "url(#linearGradient226)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path228"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g230",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g232",
    clipPath: "url(#clipPath236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15403.1,0 15149,320.582 V 0 h -25.8 v 360.77 h 25.3 L 15397.4,46.9219 V 360.77 h 25.8 V 0 h -20.1",
    style: {
      fill: "url(#linearGradient248)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path250"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g252",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g254",
    clipPath: "url(#clipPath258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 16049.6,0 v 313.328 l -142.8,-207.687 h -2.1 L 15762,313.328 V 0 h -25.8 v 360.77 h 25.3 l 144.8,-213.372 144.8,213.372 h 25.3 V 0 h -26.8",
    style: {
      fill: "url(#linearGradient270)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path272"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g274",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g276",
    clipPath: "url(#clipPath280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 16389.4,0 v 360.77 h 256.7 v -24.731 h -229.9 V 194.281 h 206.7 v -24.73 h -206.7 V 24.7305 h 232.5 V 0 h -259.3",
    style: {
      fill: "url(#linearGradient292)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path294"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g296",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g298",
    clipPath: "url(#clipPath302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 17220.5,0 -254.1,320.582 V 0 h -25.8 v 360.77 h 25.3 L 17214.8,46.9219 V 360.77 h 25.8 V 0 h -20.1",
    style: {
      fill: "url(#linearGradient314)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path316"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g318",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g320",
    clipPath: "url(#clipPath324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17680.4,336.039 V 0 h -26.8 v 336.039 h -125.7 v 24.731 h 278.3 v -24.731 h -125.8",
    style: {
      fill: "url(#linearGradient336)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path338"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g340",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g342",
    clipPath: "url(#clipPath346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11792.8,628.391 h -660.6 c -160.9,0 -291.3,130.437 -291.3,291.339 v 660.6 608.37 660.6 c 0,160.91 130.4,291.35 291.3,291.35 h 660.6 c 242.9,0 464.5,-90.93 632.7,-240.65 -195.9,-174.36 -319.3,-428.43 -319.3,-711.3 v -608.37 c 0,-282.86 123.4,-536.94 319.3,-711.299 -168.2,-149.711 -389.8,-240.64 -632.7,-240.64 M 11476.4,2502.1 V 1266.94 h 316.4 c 173.1,0 313.4,140.31 313.4,313.39 v 608.38 c 0,173.08 -140.3,313.39 -313.4,313.39 h -316.4",
    style: {
      fill: "url(#linearGradient358)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path360"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g362",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g364",
    clipPath: "url(#clipPath368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13058.2,628.391 c -242.9,0 -464.5,90.929 -632.7,240.64 195.9,174.359 319.3,428.439 319.3,711.299 v 608.37 c 0,282.87 -123.4,536.94 -319.3,711.3 168.2,149.72 389.8,240.65 632.7,240.65 242.9,0 464.5,-90.93 632.7,-240.65 -195.9,-174.36 -319.3,-428.43 -319.3,-711.3 v -608.37 c 0,-282.86 123.4,-536.94 319.3,-711.299 -168.2,-149.711 -389.8,-240.64 -632.7,-240.64 m 0,1873.709 c -173.1,0 -313.4,-140.31 -313.4,-313.4 v -608.37 c 0,-173.08 140.3,-313.39 313.4,-313.39 173.1,0 313.4,140.31 313.4,313.39 v 608.37 c 0,173.09 -140.3,313.4 -313.4,313.4",
    style: {
      fill: "url(#linearGradient380)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path382"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g384",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g386",
    clipPath: "url(#clipPath390)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g392",
    transform: "matrix(654.199,0,0,2045.2,12099.9,862.9)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(1,0,0,-1,0,1)",
    id: "image394",
    xlinkHref: "data:image/png;base64,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"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g396",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g398",
    clipPath: "url(#clipPath402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14323.5,628.391 c -242.9,0 -464.5,90.929 -632.6,240.64 195.8,174.359 319.2,428.439 319.2,711.299 v 608.37 c 0,282.87 -123.4,536.94 -319.2,711.3 168.1,149.72 389.7,240.65 632.6,240.65 240.9,0 460.9,-89.46 628.6,-236.99 -193.5,-174.25 -315.2,-426.73 -315.2,-707.61 V 941.781 c 0,-84.5 37.8,-166.562 92.2,-222.929 -123,-58.02 -260.5,-90.461 -405.6,-90.461 m 0,1873.709 c -173.1,0 -313.4,-140.31 -313.4,-313.4 v -608.37 c 0,-173.08 140.3,-313.39 313.4,-313.39 173.1,0 313.4,140.31 313.4,313.39 v 608.37 c 0,173.09 -140.3,313.4 -313.4,313.4",
    style: {
      fill: "url(#linearGradient414)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path416"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g418",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g420",
    clipPath: "url(#clipPath424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g426",
    transform: "matrix(653.199,0,0,2045.2,13362.9,862.9)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(1,0,0,-1,0,1)",
    id: "image428",
    xlinkHref: "data:image/png;base64,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"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g430",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g432",
    clipPath: "url(#clipPath436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 15245.5,1342.33 c 0,0.06 0,0.12 0,0.19 0,-0.06 0,-0.13 0,-0.19 m 1.1,4.38 v 0 0 m 1.4,5.7 c 0,0.02 0,0.06 0,0.08 0,-0.03 0,-0.05 0,-0.08 m 1.1,4.28 c 0,0.04 0,0.06 0,0.1 0,-0.03 0,-0.07 0,-0.1 m 1,4.23 c 0,0.09 0,0.15 0,0.23 0,-0.06 0,-0.17 0,-0.23 m 0.9,4.19 c 0.1,0.15 0.1,0.25 0.1,0.41 0,-0.15 0,-0.26 -0.1,-0.41 m 1,4.32 c 0.1,0.11 0.1,0.24 0.1,0.35 0,-0.12 0,-0.23 -0.1,-0.35 m 0.4,1.6 c 0,0.11 0,0.18 0.1,0.29 -0.1,-0.09 -0.1,-0.2 -0.1,-0.29 m 0.6,2.84 c 0,0.04 0,0.12 0.1,0.17 0,-0.03 -0.1,-0.14 -0.1,-0.17 m 0.3,1.42 c 0.1,0.15 0.1,0.29 0.1,0.44 0,-0.15 0,-0.29 -0.1,-0.44 m 1,4.28 c 0,0.16 0,0.3 0.1,0.45 -0.1,-0.15 -0.1,-0.3 -0.1,-0.45 m 0.9,4.25 c 0,0.18 0,0.38 0.1,0.55 -0.1,-0.18 -0.1,-0.37 -0.1,-0.55 m 0.3,1.7 c 0.1,0.18 0.1,0.39 0.1,0.56 0,-0.21 0,-0.35 -0.1,-0.56 m 0.5,2.48 c 0.1,0.24 0.1,0.48 0.2,0.72 -0.1,-0.24 -0.1,-0.48 -0.2,-0.72 m 0.4,1.82 c 0,0.18 0.1,0.37 0.1,0.54 0,-0.18 -0.1,-0.36 -0.1,-0.54 m 0.5,2.61 c 0.1,0.18 0.1,0.36 0.1,0.54 0,-0.18 0,-0.36 -0.1,-0.54 m 0.4,1.64 c 0,0.24 0.1,0.48 0.1,0.72 0,-0.24 -0.1,-0.48 -0.1,-0.72 m 0.5,2.55 c 0,0.24 0,0.44 0.1,0.68 -0.1,-0.24 -0.1,-0.44 -0.1,-0.68 m 0.3,1.77 c 0.1,0.24 0.1,0.45 0.1,0.69 0,-0.21 -0.1,-0.48 -0.1,-0.69 m 0.3,1.73 c 0.1,0.51 0.2,0.97 0.3,1.47 -0.1,-0.48 -0.2,-0.98 -0.3,-1.47 m 0.5,2.57 c 0.1,0.22 0.1,0.45 0.2,0.67 -0.1,-0.21 -0.1,-0.46 -0.2,-0.67 m 0.4,1.81 c 0,0.04 0,0.12 0,0.16 0,-0.06 0,-0.1 0,-0.16 m 0.4,2.54 c 0.1,0.2 0.1,0.43 0.2,0.63 -0.1,-0.22 -0.1,-0.41 -0.2,-0.63 m 0.4,1.73 c 0,0.23 0,0.42 0.1,0.64 -0.1,-0.21 -0.1,-0.42 -0.1,-0.64 m 0.4,2.47 c 0.1,0.28 0.1,0.53 0.1,0.82 0,-0.28 -0.1,-0.55 -0.1,-0.82 m 0.3,1.83 c 0.1,0.24 0.1,0.51 0.2,0.75 -0.1,-0.25 -0.1,-0.51 -0.2,-0.75 m 0.5,2.45 c 0,0.29 0.1,0.56 0.1,0.85 0,-0.3 -0.1,-0.54 -0.1,-0.85 m 0.3,1.82 c 0,0.29 0.1,0.58 0.1,0.87 0,-0.31 -0.1,-0.57 -0.1,-0.87 m 0.4,2.28 c 0,0.35 0.1,0.73 0.1,1.09 0,-0.37 -0.1,-0.72 -0.1,-1.09 m 0.3,2.05 c 0.1,0.29 0.1,0.57 0.2,0.86 -0.1,-0.31 -0.1,-0.56 -0.2,-0.86 m 0.3,1.82 c 0.1,0.51 0.2,1.04 0.3,1.55 -0.1,-0.52 -0.2,-1.03 -0.3,-1.55 m 0.4,2.47 c 0.1,0.31 0.1,0.61 0.2,0.92 -0.1,-0.31 -0.1,-0.61 -0.2,-0.92 m 0.3,1.87 c 0.1,0.4 0.2,0.83 0.2,1.23 -0.1,-0.43 -0.1,-0.8 -0.2,-1.23 m 0.4,2.35 c 0.1,0.36 0.1,0.7 0.2,1.05 -0.1,-0.34 -0.2,-0.71 -0.2,-1.05 m 0.3,1.96 c 0.1,0.34 0.1,0.71 0.2,1.05 -0.1,-0.34 -0.1,-0.71 -0.2,-1.05 m 0.4,2.29 c 0,0.37 0.1,0.8 0.1,1.18 0,-0.4 -0.1,-0.78 -0.1,-1.18 m 0.3,2.04 c 0,0.35 0.1,0.67 0.1,1.02 0,-0.34 -0.1,-0.69 -0.1,-1.02 m 0.3,2.07 c 0,0.44 0.1,0.89 0.2,1.34 -0.1,-0.46 -0.1,-0.88 -0.2,-1.34 m 0.3,2.34 c 0.1,0.29 0.1,0.59 0.2,0.88 -0.1,-0.28 -0.1,-0.6 -0.2,-0.88 m 0.3,1.83 c 0.1,0.52 0.1,1.04 0.2,1.55 -0.1,-0.49 -0.1,-1.05 -0.2,-1.55 m 0.4,2.48 c 0,0.31 0,0.67 0.1,0.99 -0.1,-0.34 -0.1,-0.65 -0.1,-0.99 m 0.2,1.81 c 0.1,0.45 0.1,0.94 0.2,1.39 -0.1,-0.47 -0.1,-0.92 -0.2,-1.39 m 0.4,2.5 c 0,0.33 0,0.68 0.1,1.02 -0.1,-0.34 -0.1,-0.68 -0.1,-1.02 m 0.2,1.91 c 0.1,0.4 0.1,0.81 0.2,1.22 -0.1,-0.41 -0.1,-0.82 -0.2,-1.22 m 0.3,2.24 c 0.1,0.43 0.1,0.83 0.2,1.26 -0.1,-0.44 -0.1,-0.83 -0.2,-1.26 m 0.3,2.09 c 0,0.4 0.1,0.75 0.1,1.15 0,-0.37 -0.1,-0.78 -0.1,-1.15 m 0.2,1.98 c 0.1,0.54 0.2,1.07 0.3,1.61 -0.1,-0.56 -0.2,-1.05 -0.3,-1.61 m 0.3,2.32 c 0.1,0.43 0.1,0.83 0.2,1.26 -0.1,-0.43 -0.1,-0.82 -0.2,-1.26 m 0.3,1.92 c 0.1,0.58 0.1,1.16 0.2,1.74 -0.1,-0.56 -0.1,-1.18 -0.2,-1.74 m 0.3,2.43 c 0,0.41 0.1,0.82 0.1,1.22 0,-0.4 -0.1,-0.81 -0.1,-1.22 m 0.2,1.98 c 0.1,0.58 0.2,1.14 0.2,1.72 0,-0.59 -0.1,-1.13 -0.2,-1.72 m 0.3,2.35 c 0,0.43 0.1,0.85 0.1,1.28 0,-0.44 -0.1,-0.84 -0.1,-1.28 m 0.2,2 c 0.1,0.5 0.1,1.02 0.2,1.51 -0.1,-0.49 -0.1,-1.01 -0.2,-1.51 m 0.3,2.34 c 0,0.43 0.1,0.86 0.1,1.29 0,-0.44 -0.1,-0.85 -0.1,-1.29 m 0.2,2.08 c 0.1,0.45 0.1,0.92 0.2,1.37 -0.1,-0.47 -0.1,-0.9 -0.2,-1.37 m 0.2,1.86 c 0.1,0.59 0.2,1.18 0.2,1.77 0,-0.59 -0.1,-1.17 -0.2,-1.77 m 0.3,2.49 c 0,0.45 0.1,0.92 0.1,1.38 0,-0.47 -0.1,-0.92 -0.1,-1.38 m 0.2,1.9 c 0.1,0.61 0.1,1.22 0.2,1.83 -0.1,-0.6 -0.1,-1.24 -0.2,-1.83 m 0.2,2.43 c 0.1,0.46 0.1,0.92 0.2,1.37 -0.1,-0.44 -0.1,-0.93 -0.2,-1.37 m 0.2,1.99 c 0.1,0.61 0.2,1.19 0.2,1.8 0,-0.59 -0.1,-1.21 -0.2,-1.8 m 0.3,2.36 c 0,0.47 0.1,0.94 0.1,1.42 0,-0.47 -0.1,-0.95 -0.1,-1.42 m 0.2,2.03 c 0,0.61 0.1,1.21 0.1,1.82 0,-0.59 -0.1,-1.22 -0.1,-1.82 m 0.2,2.3 c 0,0.48 0.1,1.01 0.1,1.49 0,-0.5 -0.1,-0.99 -0.1,-1.49 m 0.2,2.09 c 0,0.54 0.1,1.11 0.1,1.65 0,-0.56 -0.1,-1.09 -0.1,-1.65 m 0.1,1.98 c 0.1,0.62 0.1,1.2 0.2,1.82 -0.1,-0.63 -0.1,-1.19 -0.2,-1.82 m 0.2,2.46 c 0.1,0.47 0.1,0.94 0.2,1.42 -0.1,-0.5 -0.1,-0.92 -0.2,-1.42 m 0.2,1.95 c 0.1,0.59 0.1,1.22 0.2,1.81 -0.1,-0.6 -0.1,-1.22 -0.2,-1.81 m 0.2,2.45 c 0,0.45 0.1,0.95 0.1,1.41 0,-0.47 -0.1,-0.94 -0.1,-1.41 m 0.2,1.97 c 0,0.61 0.1,1.25 0.1,1.86 0,-0.63 -0.1,-1.23 -0.1,-1.86 m 0.1,2.38 c 0.1,0.46 0.1,0.94 0.2,1.4 -0.1,-0.47 -0.1,-0.92 -0.2,-1.4 m 0.2,2.07 c 0,0.6 0.1,1.22 0.1,1.82 0,-0.6 -0.1,-1.22 -0.1,-1.82 m 0.2,2.31 c 0,0.5 0,0.97 0.1,1.47 -0.1,-0.47 -0.1,-1 -0.1,-1.47 m 0.1,2.13 c 0.1,0.57 0.1,1.19 0.1,1.76 0,-0.6 0,-1.16 -0.1,-1.76 m 0.2,2 c 0,0.59 0,1.2 0.1,1.8 -0.1,-0.6 -0.1,-1.2 -0.1,-1.8 m 0.1,2.37 c 0,0.55 0.1,1.11 0.1,1.66 0,-0.57 -0.1,-1.09 -0.1,-1.66 m 0.1,1.97 c 0.1,0.65 0.1,1.28 0.1,1.92 0,-0.64 0,-1.28 -0.1,-1.92 m 0.2,2.48 c 0,0.5 0,0.99 0.1,1.49 -0.1,-0.5 -0.1,-0.99 -0.1,-1.49 m 0.1,1.99 c 0,0.61 0.1,1.25 0.1,1.87 0,-0.63 -0.1,-1.24 -0.1,-1.87 m 0.1,2.43 c 0.1,0.49 0.1,0.99 0.1,1.47 0,-0.47 0,-0.99 -0.1,-1.47 m 0.1,2.03 c 0.1,0.65 0.1,1.28 0.1,1.92 0,-0.64 0,-1.28 -0.1,-1.92 m 0.2,2.25 c 0,0.55 0,1.11 0,1.66 0,-0.54 0,-1.12 0,-1.66 m 0.1,2.18 c 0,0.64 0,1.27 0.1,1.91 -0.1,-0.63 -0.1,-1.28 -0.1,-1.91 m 0.1,2.22 c 0,0.57 0,1.11 0,1.69 0,-0.57 0,-1.12 0,-1.69 m 0.1,2.26 c 0,0.57 0,1.12 0,1.69 0,-0.57 0,-1.12 0,-1.69 m 0.1,1.97 c 0,0.62 0,1.28 0,1.9 0,-0.63 0,-1.27 0,-1.9 m 0,2.48 c 0.1,0.51 0.1,1.03 0.1,1.54 0,-0.51 0,-1.03 -0.1,-1.54 m 0.1,2.02 c 0,0.62 0.1,1.26 0.1,1.88 0,-0.61 -0.1,-1.28 -0.1,-1.88 m 0.1,2.44 c 0,0.51 0,0.98 0.1,1.49 -0.1,-0.51 -0.1,-0.98 -0.1,-1.49 m 0.1,2.03 c 0,0.62 0,1.27 0,1.89 0,-0.63 0,-1.26 0,-1.89 m 0.1,2.38 c 0,0.51 0,1 0,1.51 0,-0.51 0,-1 0,-1.51 m 0,2.12 c 0,0.65 0,1.29 0.1,1.93 -0.1,-0.63 -0.1,-1.29 -0.1,-1.93 m 0.1,2.07 c 0,0.6 0,1.22 0,1.82 0,-0.61 0,-1.21 0,-1.82 m 0,2.39 c 0,0.58 0,1.18 0.1,1.75 -0.1,-0.6 -0.1,-1.15 -0.1,-1.75 m 0.1,1.98 c 0,0.62 0,1.29 0,1.92 0,-0.64 0,-1.28 0,-1.92 m 0,2.51 c 0,0.53 0,1.09 0,1.62 0,-0.54 0,-1.08 0,-1.62 m 0,1.98 c 0.1,0.64 0.1,1.28 0.1,1.93 0,-0.64 0,-1.29 -0.1,-1.93 m 0.1,2.45 c 0,0.53 0,1.09 0,1.62 0,-0.54 0,-1.08 0,-1.62 m 0,2.05 c 0,0.65 0,1.31 0,1.96 0,-0.64 0,-1.32 0,-1.96 m 0,2.36 c 0,0.56 0,1.13 0,1.69 0,-0.58 0,-1.11 0,-1.69 m 0.1,2.11 c 0,0.68 0,1.32 0,2 0,-0.68 0,-1.32 0,-2 m 0,2.3 c 0,0.58 0,1.12 0,1.7 0,-0.58 0,-1.12 0,-1.7 m 0,2.26 c 0,0.65 0,1.31 0,1.96 0,-0.64 0,-1.32 0,-1.96 m 0,1.96 h -0.3 l 0.3,610.42 c 0,-0.67 0,-1.38 0,-2.05 v -608.37 0",
    style: {
      fill: "url(#linearGradient448)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path450"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g452",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g454",
    clipPath: "url(#clipPath458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 17492.8,628.391 c -173.1,0 -313.4,140.308 -313.4,313.39 l -6.4,1254.269 c 0,173.08 -140.3,313.4 -313.4,313.4 -173,0 -313.4,-140.32 -313.4,-313.4 l -11.3,-1254.269 c 0,-173.082 -140.3,-313.39 -313.4,-313.39 -173,0 -313.4,140.308 -313.4,313.39 0,0 -0.6,1283.229 0,1297.599 -21.1,152.52 -158,270.07 -316.3,270.07 -173.1,0 -316.3,-140.32 -316.3,-313.4 v -5.3 c -0.6,284.04 -125.6,538.87 -323.4,712.91 168.6,151.91 391.9,244.34 636.8,244.34 241.8,0 462.5,-90.37 630.4,-238.97 168,148.6 388.6,238.97 630.5,238.97 525.7,0 951.9,-426.2 951.9,-951.95 l 4.5,-1254.269 c 0,-173.082 -140.4,-313.39 -313.4,-313.39 m -2763.7,90.461 v 0 c 253.2,119.41 445.3,347.158 516.4,623.478 -71.1,-276.31 -263.2,-504.068 -516.4,-623.478 m 516.4,623.668 c 0.4,1.39 0.7,2.79 1.1,4.19 -0.4,-1.41 -0.7,-2.8 -1.1,-4.19 m 1.1,4.19 c 0.5,1.91 0.9,3.79 1.4,5.7 -0.5,-1.9 -0.9,-3.8 -1.4,-5.7 m 1.4,5.78 c 0.4,1.41 0.7,2.8 1.1,4.2 -0.4,-1.4 -0.7,-2.79 -1.1,-4.2 m 1.1,4.3 c 0.3,1.38 0.6,2.76 1,4.13 -0.4,-1.36 -0.7,-2.76 -1,-4.13 m 1,4.36 c 0.3,1.32 0.6,2.64 0.9,3.96 -0.3,-1.3 -0.6,-2.65 -0.9,-3.96 m 1,4.37 c 0.3,1.29 0.6,2.62 0.9,3.91 -0.3,-1.3 -0.6,-2.61 -0.9,-3.91 m 1,4.26 c 0.1,0.42 0.2,0.83 0.3,1.25 -0.1,-0.41 -0.2,-0.84 -0.3,-1.25 m 0.4,1.54 c 0.1,0.87 0.3,1.68 0.5,2.55 -0.2,-0.85 -0.4,-1.7 -0.5,-2.55 m 0.6,2.72 c 0.1,0.42 0.1,0.83 0.2,1.25 -0.1,-0.41 -0.2,-0.84 -0.2,-1.25 m 0.3,1.69 c 0.3,1.29 0.6,2.55 0.9,3.84 -0.3,-1.28 -0.6,-2.55 -0.9,-3.84 m 1,4.29 c 0.2,1.27 0.5,2.53 0.8,3.8 -0.3,-1.27 -0.6,-2.53 -0.8,-3.8 m 0.9,4.35 c 0.1,0.36 0.1,0.79 0.2,1.15 -0.1,-0.39 -0.1,-0.75 -0.2,-1.15 m 0.3,1.71 c 0.2,0.64 0.3,1.28 0.4,1.92 -0.1,-0.64 -0.2,-1.28 -0.4,-1.92 m 0.6,2.64 c 0.1,0.36 0.1,0.74 0.2,1.1 -0.1,-0.37 -0.1,-0.73 -0.2,-1.1 m 0.3,1.64 c 0.1,0.67 0.3,1.4 0.4,2.07 -0.1,-0.7 -0.2,-1.37 -0.4,-2.07 m 0.5,2.61 c 0.1,0.36 0.2,0.74 0.3,1.1 -0.1,-0.37 -0.2,-0.73 -0.3,-1.1 m 0.4,1.82 c 0.1,0.61 0.2,1.22 0.4,1.83 -0.2,-0.6 -0.3,-1.23 -0.4,-1.83 m 0.5,2.51 c 0.1,0.36 0.1,0.72 0.2,1.09 -0.1,-0.36 -0.1,-0.74 -0.2,-1.09 m 0.3,1.78 c 0.1,0.36 0.2,0.68 0.2,1.04 0,-0.33 -0.1,-0.71 -0.2,-1.04 m 0.5,2.51 c 0.1,0.37 0.2,0.73 0.2,1.1 0,-0.36 -0.1,-0.75 -0.2,-1.1 m 0.4,1.77 c 0,0.4 0.1,0.74 0.2,1.14 -0.1,-0.4 -0.2,-0.74 -0.2,-1.14 m 0.2,1.3 c 0.1,0.79 0.3,1.59 0.4,2.38 -0.1,-0.79 -0.3,-1.58 -0.4,-2.38 m 0.6,3.01 c 0,0.36 0.1,0.74 0.2,1.1 -0.1,-0.37 -0.2,-0.73 -0.2,-1.1 m 0.3,1.74 c 0.1,0.61 0.2,1.22 0.3,1.83 -0.1,-0.6 -0.2,-1.23 -0.3,-1.83 m 0.4,2.65 c 0.1,0.33 0.2,0.67 0.2,1.01 0,-0.33 -0.1,-0.68 -0.2,-1.01 m 0.4,1.76 c 0.1,0.55 0.2,1.15 0.3,1.7 -0.1,-0.57 -0.2,-1.13 -0.3,-1.7 m 0.4,2.55 c 0.1,0.31 0.1,0.66 0.2,0.97 -0.1,-0.31 -0.1,-0.66 -0.2,-0.97 m 0.3,1.84 c 0.1,0.46 0.2,0.95 0.3,1.41 -0.1,-0.49 -0.2,-0.93 -0.3,-1.41 m 0.4,2.5 c 0.1,0.3 0.2,0.65 0.2,0.96 0,-0.31 -0.1,-0.65 -0.2,-0.96 m 0.4,1.82 c 0,0.31 0.1,0.65 0.1,0.96 0,-0.34 -0.1,-0.63 -0.1,-0.96 m 0.4,2.51 c 0,0.31 0.1,0.61 0.1,0.92 0,-0.31 -0.1,-0.61 -0.1,-0.92 m 0.3,1.84 c 0,0.31 0.1,0.65 0.1,0.95 0,-0.31 -0.1,-0.64 -0.1,-0.95 m 0.3,2.18 c 0.1,0.37 0.1,0.75 0.2,1.12 -0.1,-0.38 -0.1,-0.75 -0.2,-1.12 m 0.4,2.17 c 0,0.31 0.1,0.61 0.1,0.91 0,-0.31 -0.1,-0.6 -0.1,-0.91 m 0.3,1.96 c 0,0.43 0.1,0.8 0.2,1.24 -0.1,-0.43 -0.2,-0.82 -0.2,-1.24 m 0.3,2.42 c 0.1,0.28 0.1,0.58 0.2,0.86 -0.1,-0.29 -0.1,-0.57 -0.2,-0.86 m 0.3,1.88 c 0.1,0.34 0.1,0.71 0.2,1.05 -0.1,-0.34 -0.1,-0.71 -0.2,-1.05 m 0.4,2.39 c 0,0.34 0.1,0.66 0.1,1 0,-0.33 -0.1,-0.67 -0.1,-1 m 0.3,1.88 c 0,0.34 0,0.61 0.1,0.95 -0.1,-0.33 -0.1,-0.62 -0.1,-0.95 m 0.3,2.5 c 0.1,0.31 0.1,0.62 0.2,0.93 -0.1,-0.31 -0.1,-0.61 -0.2,-0.93 m 0.3,1.92 c 0,0.28 0.1,0.55 0.1,0.82 0,-0.29 -0.1,-0.53 -0.1,-0.82 m 0.3,2.21 c 0.1,0.37 0.1,0.74 0.2,1.11 -0.1,-0.38 -0.1,-0.73 -0.2,-1.11 m 0.3,2.13 c 0,0.27 0.1,0.61 0.1,0.89 0,-0.3 -0.1,-0.6 -0.1,-0.89 m 0.3,2.11 c 0,0.34 0.1,0.68 0.1,1.02 0,-0.34 -0.1,-0.69 -0.1,-1.02 m 0.3,2.28 c 0,0.28 0.1,0.55 0.1,0.83 0,-0.27 -0.1,-0.56 -0.1,-0.83 m 0.2,1.98 c 0.1,0.28 0.1,0.55 0.1,0.83 0,-0.27 0,-0.56 -0.1,-0.83 m 0.4,2.44 c 0,0.22 0,0.49 0,0.71 0,-0.22 0,-0.48 0,-0.71 m 0.2,1.97 c 0,0.22 0.1,0.44 0.1,0.66 0,-0.23 -0.1,-0.43 -0.1,-0.66 m 0.3,2.4 c 0,0.25 0.1,0.45 0.1,0.69 0,-0.22 -0.1,-0.46 -0.1,-0.69 m 0.2,1.91 c 0.1,0.25 0.1,0.51 0.1,0.76 0,-0.25 0,-0.51 -0.1,-0.76 m 0.3,2.48 c 0,0.19 0.1,0.44 0.1,0.63 0,-0.2 -0.1,-0.42 -0.1,-0.63 m 0.2,1.91 c 0.1,0.25 0.1,0.47 0.1,0.72 0,-0.25 0,-0.48 -0.1,-0.72 m 0.3,2.23 c 0,0.29 0.1,0.55 0.1,0.83 0,-0.27 -0.1,-0.55 -0.1,-0.83 m 0.2,2.12 c 0.1,0.25 0.1,0.54 0.1,0.79 0,-0.27 0,-0.52 -0.1,-0.79 m 0.3,2.16 c 0,0.15 0,0.34 0,0.49 0,-0.15 0,-0.33 0,-0.49 m 0.2,2.26 c 0,0.22 0.1,0.5 0.1,0.72 0,-0.25 -0.1,-0.47 -0.1,-0.72 m 0.2,2.1 c 0.1,0.18 0.1,0.33 0.1,0.52 0,-0.18 0,-0.34 -0.1,-0.52 m 0.3,2.35 c 0,0.22 0,0.38 0,0.6 0,-0.2 0,-0.4 0,-0.6 m 0.2,1.97 c 0,0.22 0,0.4 0,0.62 0,-0.21 0,-0.42 0,-0.62 m 0.2,2.42 c 0,0.19 0,0.37 0.1,0.56 -0.1,-0.18 -0.1,-0.38 -0.1,-0.56 m 0.2,1.98 c 0,0.22 0,0.39 0.1,0.61 -0.1,-0.2 -0.1,-0.41 -0.1,-0.61 m 0.2,2.43 c 0,0.16 0.1,0.32 0.1,0.48 0,-0.16 -0.1,-0.32 -0.1,-0.48 m 0.2,1.97 c 0,0.19 0,0.41 0.1,0.6 -0.1,-0.21 -0.1,-0.39 -0.1,-0.6 m 0.2,2.25 c 0,0.1 0,0.24 0,0.33 0,-0.11 0,-0.22 0,-0.33 m 0.2,2.15 c 0,0.19 0,0.45 0,0.64 0,-0.21 0,-0.44 0,-0.64 m 0.2,2.06 c 0,0.16 0,0.37 0,0.53 0,-0.19 0,-0.35 0,-0.53 m 0.2,2.34 c 0,0.22 0,0.42 0,0.64 0,-0.23 0,-0.41 0,-0.64 m 0.1,2.05 c 0,0.19 0.1,0.37 0.1,0.56 -0.1,-0.21 -0.1,-0.36 -0.1,-0.56 m 0.2,2.42 c 0,0.16 0,0.37 0,0.52 0,-0.18 0,-0.34 0,-0.52 m 0.2,1.92 c 0,0.22 0,0.45 0,0.67 0,-0.22 0,-0.44 0,-0.67 m 0.1,2.49 c 0,0.19 0.1,0.3 0.1,0.49 0,-0.16 -0.1,-0.33 -0.1,-0.49 m 0.2,1.96 c 0,0.22 0,0.44 0,0.66 0,-0.23 0,-0.43 0,-0.66 m 0.1,2.42 c 0,0.07 0,0.18 0.1,0.24 -0.1,-0.09 -0.1,-0.15 -0.1,-0.24 m 0.2,2.04 c 0,0.19 0,0.38 0,0.57 0,-0.18 0,-0.39 0,-0.57 m 0.1,2.23 c 0,0.1 0,0.22 0,0.31 0,-0.11 0,-0.2 0,-0.31 m 0.1,2.23 c 0.1,0.19 0.1,0.37 0.1,0.56 0,-0.19 0,-0.38 -0.1,-0.56 m 0.2,2.05 c 0,0.16 0,0.34 0,0.5 0,-0.16 0,-0.34 0,-0.5 m 0.1,2.37 c 0,0.19 0,0.38 0,0.56 0,-0.2 0,-0.35 0,-0.56 m 0.1,2.03 c 0,0.19 0,0.37 0,0.56 0,-0.18 0,-0.38 0,-0.56 m 0.1,2.48 c 0,0.13 0.1,0.2 0.1,0.33 0,-0.11 -0.1,-0.22 -0.1,-0.33 m 0.1,1.99 c 0,0.19 0.1,0.33 0.1,0.52 0,-0.16 -0.1,-0.36 -0.1,-0.52 m 0.2,2.43 c 0,0.1 0,0.21 0,0.31 0,-0.1 0,-0.21 0,-0.31 m 0,2 c 0.1,0.19 0.1,0.38 0.1,0.57 0,-0.19 0,-0.39 -0.1,-0.57 m 0.1,2.26 c 0,0.07 0,0.21 0.1,0.28 -0.1,-0.1 -0.1,-0.18 -0.1,-0.28 m 0.1,2.18 c 0,0.23 0,0.36 0,0.58 0,-0.2 0,-0.37 0,-0.58 m 0.1,2.12 c 0,0.15 0,0.32 0,0.48 0,-0.16 0,-0.32 0,-0.48 m 0.1,2.36 c 0,0.19 0,0.37 0,0.56 0,-0.18 0,-0.38 0,-0.56 m 0.1,2.05 c 0,0.15 0,0.38 0,0.54 0,-0.19 0,-0.36 0,-0.54 m 0,2.43 c 0,0.16 0,0.33 0.1,0.49 -0.1,-0.16 -0.1,-0.32 -0.1,-0.49 m 0.1,2 c 0,0.22 0,0.39 0,0.61 0,-0.21 0,-0.4 0,-0.61 m 0.1,2.54 c 0,0.04 0,0.11 0,0.14 0,-0.04 0,-0.09 0,-0.14 m 0,1.96 c 0,0.19 0,0.38 0,0.57 0,-0.19 0,-0.39 0,-0.57 m 0.1,2.32 c 0,0.07 0,0.17 0,0.23 0,-0.09 0,-0.13 0,-0.23 m 0,2.15 c 0,0.19 0,0.4 0,0.59 0,-0.21 0,-0.38 0,-0.59 m 0,2.21 c 0,0.13 0,0.23 0,0.36 0,-0.12 0,-0.24 0,-0.36 m 0.1,2.29 c 0,0.16 0,0.36 0,0.52 0,-0.19 0,-0.33 0,-0.52 m 0,2.14 c 0,0.16 0,0.27 0,0.43 0,-0.14 0,-0.29 0,-0.43 m 0,2.39 c 0,0.13 0,0.28 0,0.4 0,-0.14 0,-0.26 0,-0.4 m 0,2.09 c 0,0.13 0,0.29 0.1,0.42 -0.1,-0.14 -0.1,-0.28 -0.1,-0.42 m 0.1,2.42 c 0,0.09 0,0.21 0,0.3 0,-0.09 0,-0.21 0,-0.3 m 0,2 c 0,0.19 0,0.36 0,0.56 0,-0.19 0,-0.37 0,-0.56",
    style: {
      fill: "url(#linearGradient470)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path472"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g474",
    transform: "matrix(0.96909, 0, 0, 0.952986, -5.802063, 898.000061)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "g476",
    clipPath: "url(#clipPath480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g482",
    transform: "matrix(654.199,0,0,2204.2,14629.9,708.9)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(1,0,0,-1,0,1)",
    id: "image484",
    xlinkHref: "data:image/png;base64,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"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoomLogo);
export default __webpack_public_path__ + "static/media/DOOM-logo.3a53b0a67816132c1cf85ef9999f3d89.svg";
export { ForwardRef as ReactComponent };